import { Box, Stack, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import { TicketsTable } from './TicketsTable';
import { TransactionsTable } from './TransactionsTable';

export const EditExperienceTable = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Stack pb={8}>
      <Tabs
        sx={{
          '& .MuiTabs-list': {
            gap: '35px',
            backgroundColor: 'red',
          },
        }}
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        <Tab label="Passes" id="tickets-table" />
        <Tab label="Ticket Transaction" id="transaction-table" />
      </Tabs>
      <Box px={2}>
        <TicketsTable value={value} index={0} />
        <TransactionsTable value={value} index={1} />
      </Box>
    </Stack>
  );
};
